import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Select } from '@ngxs/store';
import { UiState } from '@ngxs-store/ui-store/ui.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-not-found-page',
  template: `
  <div>
    <app-not-found></app-not-found>
  </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundPageComponent {

  constructor() { }

}
